module.exports = __webpack_public_path__ + "static/media/训练平台icon.cd04aa5f.png";